import { MD5} from 'crypto-js'
import CryptoJS from 'crypto-js'
export function md5(str) {

    const md5 = MD5(str)

      return wordsToHexString(md5.words)
  }

  function wordsToHexString(md5_words) {
    let hexString = '';
    for (let i = 0; i < md5_words.length; i++) {
      // Convert the 32-bit word to a hexadecimal string
      // Use >>> 0 to ensure unsigned 32-bit representation
      // toString(16) converts to hex
      // padStart(8, '0') ensures each word is 8 hex characters long
      let hexWord = (md5_words[i] >>> 0).toString(16).padStart(8, '0');
      hexString += hexWord;
    }
    return hexString;
  }

  function uint8ArrayToHexString(byteArray) {
    let hexString = "";
    for (let i = 0; i < byteArray.length; i++) {
    let hex = byteArray[i].toString(16); // 转换为16进制
    if (hex.length === 1) {
    hex = "0" + hex; // 补零
    }
    hexString += hex;
    }
    return hexString;
    }

  export function random(byteLength) {
    

// 创建一个Uint8Array视图来访问ArrayBuffer 
    // 创建一个ArrayBuffer
    const buffer = new ArrayBuffer(byteLength);
    // 创建一个Uint8Array视图
    const uint8Array = new Uint8Array(buffer);
    // 使用crypto.getRandomValues填充Uint8Array
    window.crypto.getRandomValues(uint8Array);
    // 返回填充后的Uint8Array作为结果
    // return uint8Array;
 
    return uint8ArrayToHexString(uint8Array);

  }
  
  export function randomUint32(length) {
    const buffer = new ArrayBuffer(length);
    // 创建一个Uint8Array视图
    const uint8Array = new Uint8Array(buffer);
    // 使用crypto.getRandomValues填充Uint8Array
    window.crypto.getRandomValues(uint8Array);
    // 返回填充后的Uint8Array作为结果
    // return uint8Array;
 
    
    const dataView = new DataView(uint8Array.buffer);

    return dataView.getUint32(0,false)

    // return bytesToUint32(crypto.randomBytes(length))
  }
  export function GenerateSignature(request) {
    //时间戳，毫秒
    const XTimestamp = Date.now()
    //32位随机数
    const XNonce = randomUint32(4)
    //取请求body的哈希值
    const body_md5_hash = request.bodyStr ? md5(request.bodyStr) : ''
  
    //将参数转换为小写重新排序
    const query = request.query.toLowerCase().split('&').sort().join(':')
  
    const data = GenerateData(
      XTimestamp,
      XNonce,
      request.url,
      query,
      body_md5_hash,
      request.Authorization
    )
  
    console.log('data111111',data)
    const secretKey = 'xViJDfbh'
  
    const key = md5(`${XNonce}${secretKey}`)
    //生成加密签名
    const XSignature = sha256(data, key)
    return {
      XTimestamp,
      XNonce,
      XSignature
    }
  }
  /**
 * 生成待加密数据
 * @param XTimestamp 当前时间戳
 * @param XNonce    随机数
 * @param url       请求url
 * @param query     请求参数
 * @param body_md5_hash   请求body的md5
 * @param Authorization 授权用户token
 * @returns
 */
export function GenerateData(
    XTimestamp,
    XNonce,
    url,
    query,
    body_md5_hash,
    Authorization
  ) {
    //加密格式 ${X-Timestamp}:${X-Nonce}[:${Authorization}]:${url}:${query}[:${body_md5_hash}
    const match = new RegExp(':{2,}', 'g')
    const data1=Authorization?`${XTimestamp}:${XNonce}:${Authorization}:${url}:${query}:${body_md5_hash}`:`${XTimestamp}:${XNonce}:${url}:${query}:${body_md5_hash}`
    const data = data1
      .replace(match, ':') //去掉中间连续的冒号
      .replace(/:$/, '') //去掉最后一个冒号
    return data
  }
  export function sha256(data, key) {

    
    const HmacSHA256 = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key)
    HmacSHA256.update(data)
    return HmacSHA256.finalize().toString()
  }
  